import { reviewProposedTimeLinkText, editEventLinkText } from './EditEventLink.locstring.json';
import loc from 'owa-localize';
import generatePartialEventForProposeNewTime from '../utils/generatePartialEventForProposeNewTime';
import getCalendarDeepLinkUrl from '../utils/getCalendarDeepLinkUrl';
import { MeetingMessageActionType } from '../utils/MeetingMessageActionType';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { isFeatureEnabled } from 'owa-feature-flags';
import { popoutCalendarComposeWithItemId } from 'owa-popout/lib/utils/popout/popoutCalendarCompose';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingResponseMessage from 'owa-service/lib/contract/MeetingResponseMessageType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { observer } from 'mobx-react-lite';

import * as React from 'react';

const styles = require('./MeetingResponseInfo.scss');
const classNames = require('classnames/bind').bind(styles);

export interface EditEventLinkProps {
    item: MeetingResponseMessage;
    logAction: (interactionType: MeetingMessageActionType, propertyNames?: string[]) => void;
    editLinkClassName?: string;
    editLinkText?: string;
}

const EditEventLink = (props: EditEventLinkProps) => {
    const { item, logAction, editLinkClassName, editLinkText } = props;

    const onClick = React.useCallback(() => {
        logAction('ReviewPNT');
        popoutCalendarComposeWithItemId(
            item.AssociatedCalendarItemId,
            partialEvent,
            'Mail_AcceptPNT'
        );
    }, [item, logAction]);

    // If there is no calendar item created yet, or if the user is not the organizer of the calendar item
    if (!item.AssociatedCalendarItemId || !(item as MeetingMessage).IsOrganizer) {
        return null;
    }

    // Generate the partial event which contains proposed time and attendee information
    const partialEvent = item.ProposedStart ? generatePartialEventForProposeNewTime(item) : null;

    const editLinkStyles = classNames(styles.editLink, editLinkClassName);

    const linkElement = isReactCalendarEnabled() ? (
        <Link className={editLinkStyles} onClick={onClick}>
            {editLinkText || loc(reviewProposedTimeLinkText)}
        </Link>
    ) : (
        <Link
            className={editLinkStyles}
            href={getCalendarDeepLinkUrl(item.AssociatedCalendarItemId.Id, true /* isEdit */)}
            target={item.AssociatedCalendarItemId.Id}>
            {editLinkText || loc(editEventLinkText)}
        </Link>
    );

    return <div className={styles.editLinkContainer}>{linkElement}</div>;
};

function isReactCalendarEnabled(): boolean {
    const userOptions = getUserConfiguration().UserOptions;
    return (
        isFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
    );
}

export default observer(EditEventLink);
